import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ClientConfigService, IClientConfig } from 'client-config-service-lib';
import { BullhornEntityTypes } from 'datasource-service-lib';
import { Namespace } from 'enums-lib';
import { BullhornIconService } from 'icon-service-lib';
import { jwtDecode } from 'jwt-decode';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { IdentityStorage } from 'storage-service-lib';
import { environment } from '../../../../environments/environment';
import { templateContext } from '../../../utils/template-context';
import { IAiAssistPromptService } from './iaiassistpromptservice';
import { IPrompt } from './iprompt';

@Injectable({ providedIn: 'root' })
export class BullhornAiAssistPromptService implements IAiAssistPromptService {
  private static readonly INTEGRATION_AWESOME_DOCS = 'awesomedocs';

  private kpaConfigCache = new BehaviorSubject<IClientConfig | null>(null);
  private kpaConfigCache$ = this.kpaConfigCache.asObservable();

  constructor(
    private http: HttpClient,
    private identityStorage: IdentityStorage,
    private iconService: BullhornIconService,
    private clientConfigService: ClientConfigService) {}

  getPrompts(): Observable<IPrompt[]> {
    const templateTargetEntity = templateContext.getTargetEntity().entity;

    return this.http
      .get<any[]>(`${environment.aiAssistApiUrl}/prompts/${Namespace.bullhorn}-${this.getCorpId()}`, {
        headers: {
          'x-api-key': environment.aiAssistApiKey,
        },
      })
      .pipe(
        map((prompts) => {
          return prompts
            .filter((prompt: any) => prompt.integration === BullhornAiAssistPromptService.INTEGRATION_AWESOME_DOCS)
            .map((prompt: any) => ({
              id: prompt.promptId,
              corpId: prompt.corpId,
              displayName: prompt.displayName,
              entityType: prompt.entityType,
            }))
            .filter((prompt: IPrompt) => this.keepPrompt(templateTargetEntity, prompt));
        })
      );
  }

  isEnabled(): Observable<boolean> {
    return this.clientConfigService.isAiAssistEnabled().pipe(
      map((isAiAssistEnabled) => {
        const targetEntity = templateContext.getTargetEntity().entity;
        return (
          (targetEntity === BullhornEntityTypes.Candidate ||
            targetEntity === BullhornEntityTypes.JobSubmission ||
            targetEntity === BullhornEntityTypes.JobOrder) &&
          isAiAssistEnabled
        );
      })
    );
  }

  getIcon(prompt: IPrompt): string {
    return this.iconService.getIcon(prompt.entityType);
  }

  private keepPrompt(templateEntity: string, prompt: IPrompt): boolean {
    if (templateEntity === BullhornEntityTypes.JobSubmission) {
      return prompt.entityType === BullhornEntityTypes.JobSubmission || prompt.entityType === BullhornEntityTypes.Candidate;
    }

    if (templateEntity === BullhornEntityTypes.Candidate) {
      return prompt.entityType === BullhornEntityTypes.Candidate;
    }

    if (templateEntity === BullhornEntityTypes.JobOrder) {
      return prompt.entityType === BullhornEntityTypes.JobOrder;
    }

    return false;
  }

  private getCorpId(): string {
    const identity = this.identityStorage.get();
    const { token } = identity;
    const decodedToken = jwtDecode<any>(token);
    return decodedToken.corporationId;
  }
}
